/* ═══════════════════════════════════════════════════════════
   Smith's Blades — Collection Page JavaScript (Unified)
   Handles: Standard collections (swords) + Dual-collection (knives)
   Auto-detects collection type and applies appropriate logic
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ════════════════════════════════════════
     DETECT COLLECTION TYPE
     ════════════════════════════════════════ */
  let isDualCollection = false;
  
  // Will be set after DOM loads
  function detectCollectionType() {
    const grid = document.getElementById('allGrid');
    if (grid && grid.dataset.knivesCollection !== undefined) {
      isDualCollection = true;
      console.log('✓ Dual-collection mode detected (knives + chef-sets)');
    } else {
      console.log('✓ Standard collection mode detected');
    }
  }

  /* ════════════════════════════════════════
   PRODUCT CARD CLICK HANDLER
   ════════════════════════════════════════ */
  function initCardClicks() {
    document.addEventListener('click', function(e) {
      const card = e.target.closest('.product-card');
      
      if (!card) return;

      // Wishlist button — let wishlist.js handle it
      if (e.target.closest('.wishlist-toggle') || e.target.closest('.card-wishlist')) {
        return;
      }

      // Quick View button — open quick view
      if (e.target.closest('.card-quickview')) {
        e.preventDefault();
        e.stopPropagation();
        
        const productUrl = card.dataset.productUrl;
        if (productUrl) {
          const handle = productUrl.split('/products/')[1]?.split('?')[0];
          if (handle && window.openQuickView) {
            window.openQuickView(handle);
          }
        }
        return;
      }

      // Otherwise, navigate to product page
      const productUrl = card.dataset.productUrl;
      if (productUrl) {
        window.location.href = productUrl;
      }
    });

    console.log('✓ Card click handlers initialized');
  }

  /* ════════════════════════════════════════
     TAB SWITCHING
     ════════════════════════════════════════ */
  function initTabs() {
    const tabs = document.querySelectorAll('.tax-tab');
    const panels = {
      all:         document.getElementById('viewAll'),
      movies:      document.getElementById('viewMovies'),
      traditional: document.getElementById('viewTraditional'),
    };
    
    const resultCount = document.getElementById('resultCount');

    if (!tabs.length || !panels.all) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        tabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        const view = this.dataset.view;

        Object.values(panels).forEach(p => {
          if (p) p.classList.remove('active');
        });

        if (panels[view]) {
          panels[view].classList.add('active');
        }

        if (resultCount) {
          const activePanel = panels[view];
          if (activePanel) {
            const productCount = activePanel.querySelectorAll('.product-card').length;
            resultCount.textContent = productCount + ' Pieces';
          }
        }

        initRowArrows();
        initReveal();
        scrollToContent();
      });
    });
  }

  /* ════════════════════════════════════════
     SCROLL TO CONTENT
     ════════════════════════════════════════ */
  function scrollToContent() {
    setTimeout(() => {
      const taxonomyBar = document.querySelector('.taxonomy-bar');
      
      if (taxonomyBar) {
        const navHeight = parseInt(
          getComputedStyle(document.documentElement)
            .getPropertyValue('--nav-height')
            .trim()
        ) || 80;
        
        const yOffset = -navHeight;
        const element = taxonomyBar;
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }, 100);
  }

  /* ════════════════════════════════════════
     SORT DROPDOWN
     ════════════════════════════════════════ */
  function initSort() {
    const sortTrigger = document.getElementById('sortTrigger');
    const sortMenu = document.getElementById('sortMenu');
    const sortLabel = document.getElementById('sortLabel');
    
    if (!sortTrigger || !sortMenu) return;

    sortTrigger.addEventListener('click', function(e) {
      e.stopPropagation();
      sortMenu.classList.toggle('open');
      sortTrigger.classList.toggle('open');
    });

    const sortOptions = document.querySelectorAll('.sort-option');
    sortOptions.forEach(option => {
      option.addEventListener('click', function() {
        sortOptions.forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');

        if (sortLabel) {
          sortLabel.textContent = 'Sort: ' + this.textContent.trim();
        }

        sortMenu.classList.remove('open');
        sortTrigger.classList.remove('open');

        const sortValue = this.dataset.sort;
        console.log('Sort by:', sortValue);
      });
    });

    document.addEventListener('click', function() {
      sortMenu.classList.remove('open');
      sortTrigger.classList.remove('open');
    });
  }

  /* ════════════════════════════════════════
     VIEW TOGGLE (Grid / List)
     ════════════════════════════════════════ */
  function initViewToggle() {
    const buttons = document.querySelectorAll('.view-toggle button');
    const grid = document.getElementById('allGrid');
    
    if (!buttons.length) return;

    buttons.forEach(btn => {
      btn.addEventListener('click', function() {
        buttons.forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        if (grid) {
          const layout = this.dataset.layout;
          if (layout === 'list') {
            grid.classList.add('list-view');
          } else {
            grid.classList.remove('list-view');
          }
        }
      });
    });
  }

  /* ════════════════════════════════════════
     HORIZONTAL SCROLL ARROWS
     ════════════════════════════════════════ */
  function initRowArrows() {
    const arrows = document.querySelectorAll('.row-arrow');
    
    arrows.forEach(btn => {
      btn.onclick = function() {
        const targetId = this.dataset.target;
        const track = document.getElementById(targetId);
        
        if (!track) return;

        const dir = parseInt(this.dataset.dir, 10);
        const cardWidth = track.querySelector('.product-card')?.offsetWidth || 240;
        const scrollAmount = (cardWidth + 20) * 4;

        track.scrollBy({
          left: dir * scrollAmount,
          behavior: 'smooth'
        });
      };
    });

    const tracks = document.querySelectorAll('.scroll-track');
    tracks.forEach(track => {
      const updateArrows = () => {
        const row = track.closest('.scroll-row');
        if (!row) return;

        const leftArrow = row.querySelector('.row-arrow.left');
        const rightArrow = row.querySelector('.row-arrow.right');
        
        if (!leftArrow || !rightArrow) return;

        const maxScroll = track.scrollWidth - track.clientWidth - 4;
        
        if (track.scrollLeft <= 4) {
          leftArrow.classList.add('disabled');
        } else {
          leftArrow.classList.remove('disabled');
        }

        if (track.scrollLeft >= maxScroll) {
          rightArrow.classList.add('disabled');
        } else {
          rightArrow.classList.remove('disabled');
        }
      };

      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  }

  /* ════════════════════════════════════════
     SCROLL REVEAL ANIMATION
     ════════════════════════════════════════ */
  function initReveal() {
    const elements = document.querySelectorAll('.reveal:not(.visible)');
    
    if (!elements.length) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(el => observer.observe(el));
  }

  /* ════════════════════════════════════════
     LOAD MORE BUTTON (UNIFIED)
     Detects collection type and uses appropriate logic
     ════════════════════════════════════════ */
  function initLoadMore() {
    const loadMoreBtn = document.getElementById('loadMoreBtn');
    if (!loadMoreBtn) return;

    const grid = document.getElementById('allGrid');
    if (!grid) return;

    // Check if this is a dual-collection grid (knives + chef-sets)
    if (grid.dataset.knivesCollection !== undefined) {
      initLoadMoreDualCollection(loadMoreBtn, grid);
    } else {
      initLoadMoreStandard(loadMoreBtn, grid);
    }
  }

  /* ════════════════════════════════════════
     LOAD MORE: STANDARD (Swords, Axes, etc.)
     ════════════════════════════════════════ */
  function initLoadMoreStandard(loadMoreBtn, grid) {
    const collectionHandle = grid.dataset.collectionHandle;
    const productsPerPage  = parseInt(grid.dataset.productsPerPage) || 8;
    const totalProducts    = parseInt(grid.dataset.totalProducts)   || 0;

    let currentPage = 2; // Page 1 already rendered by Liquid
    let loadedCount = grid.querySelectorAll('.product-card').length;
    let isLoading   = false;

    if (loadedCount >= totalProducts) {
      const wrap = loadMoreBtn.closest('.load-more-wrap');
      if (wrap) wrap.style.display = 'none';
      return;
    }

    loadMoreBtn.addEventListener('click', function() {
      if (isLoading) return;

      isLoading = true;

      const btn          = this;
      const originalText = btn.textContent.trim();

      btn.textContent   = 'Loading...';
      btn.disabled      = true;
      btn.style.opacity = '0.6';

      // ✅ Sends ?page=2 which paginate reads automatically
      const url = window.location.origin
        + '/collections/' + collectionHandle
        + '?view=load-more'
        + '&page='  + currentPage
        + '&limit=' + productsPerPage;

      fetch(url)
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function(html) {
          const trimmed = html.trim();

          if (!trimmed) {
            const wrap = btn.closest('.load-more-wrap');
            if (wrap) wrap.style.display = 'none';
            isLoading = false;
            return;
          }

          const parser      = new DOMParser();
          const doc         = parser.parseFromString(trimmed, 'text/html');
          const newProducts = doc.querySelectorAll('.product-card');

          if (newProducts.length === 0) {
            const wrap = btn.closest('.load-more-wrap');
            if (wrap) wrap.style.display = 'none';
            isLoading = false;
            return;
          }

          const existingIds = Array.from(grid.querySelectorAll('.product-card'))
            .map(function(card) { return card.dataset.productId; });

          const fragment = document.createDocumentFragment();
          let appendedCount = 0;

          newProducts.forEach(function(card) {
            if (!existingIds.includes(card.dataset.productId)) {
              fragment.appendChild(card.cloneNode(true));
              appendedCount++;
            }
          });

          if (appendedCount > 0) {
            grid.appendChild(fragment);
            loadedCount += appendedCount;
            currentPage += 1;
          }

          refreshWishlistButtons();

          if (loadedCount >= totalProducts || appendedCount === 0) {
            const wrap = btn.closest('.load-more-wrap');
            if (wrap) wrap.style.display = 'none';
          } else {
            btn.textContent   = originalText;
            btn.disabled      = false;
            btn.style.opacity = '1';
          }

          isLoading = false;
        })
        .catch(function(err) {
          console.error('❌ Load More error:', err);
          btn.textContent   = originalText;
          btn.disabled      = false;
          btn.style.opacity = '1';
          isLoading         = false;
        });
    });

    console.log('✓ Standard Load More initialized (page-based)');
  }

  /* ════════════════════════════════════════
     LOAD MORE: DUAL-COLLECTION (Knives + Chef Sets)
     ════════════════════════════════════════ */
  function initLoadMoreDualCollection(loadMoreBtn, grid) {
    const collectionHandle    = grid.dataset.collectionHandle;
    const productsPerPage     = parseInt(grid.dataset.productsPerPage) || 8;
    const totalProducts       = parseInt(grid.dataset.totalProducts)   || 0;
    const knivesCollection    = grid.dataset.knivesCollection || 'knives';
    const chefCollection      = grid.dataset.chefCollection   || 'chef-sets';

    let knivesOffset = parseInt(grid.dataset.knivesOffset) || 0;
    let chefOffset   = parseInt(grid.dataset.chefOffset)   || 0;
    let isLoading    = false;

    const currentCount = grid.querySelectorAll('.product-card').length;
    
    if (currentCount >= totalProducts) {
      const wrap = loadMoreBtn.closest('.load-more-wrap');
      if (wrap) wrap.style.display = 'none';
      return;
    }

    loadMoreBtn.addEventListener('click', function() {
      if (isLoading) return;

      isLoading = true;

      const btn          = this;
      const originalText = btn.textContent.trim();

      btn.textContent   = 'Loading...';
      btn.disabled      = true;
      btn.style.opacity = '0.6';

      const url = window.location.origin
        + '/collections/' + collectionHandle
        + '?view=knives-load-more'
        + '&knives_offset=' + knivesOffset
        + '&chef_offset=' + chefOffset
        + '&limit=' + productsPerPage;

      fetch(url)
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function(html) {
          const trimmed = html.trim();

          if (!trimmed) {
            const wrap = btn.closest('.load-more-wrap');
            if (wrap) wrap.style.display = 'none';
            isLoading = false;
            return;
          }

          const parser      = new DOMParser();
          const doc         = parser.parseFromString(trimmed, 'text/html');
          const newProducts = doc.querySelectorAll('.product-card');

          if (newProducts.length === 0) {
            const wrap = btn.closest('.load-more-wrap');
            if (wrap) wrap.style.display = 'none';
            isLoading = false;
            return;
          }

          const existingIds = Array.from(grid.querySelectorAll('.product-card'))
            .map(function(card) { return card.dataset.productId; });

          const fragment = document.createDocumentFragment();
          let appendedCount = 0;

          newProducts.forEach(function(card) {
            const productId = card.dataset.productId;
            
            if (!existingIds.includes(productId)) {
              fragment.appendChild(card.cloneNode(true));
              appendedCount++;
            }
          });

          if (appendedCount > 0) {
            grid.appendChild(fragment);
            
            // Update offsets (half went to each collection)
            const halfBatch = productsPerPage / 2;
            knivesOffset += halfBatch;
            chefOffset += halfBatch;
            
            grid.dataset.knivesOffset = knivesOffset;
            grid.dataset.chefOffset = chefOffset;
          }

          /* Re-init wishlist buttons for newly added cards */
          if (window.SmithsWishlist) {
            document.querySelectorAll('.wishlist-toggle').forEach(function(btn) {
              var handle = btn.getAttribute('data-wishlist-handle');
              if (!handle) return;
              if (window.SmithsWishlist.has(handle)) {
                btn.classList.add('is-active');
              } else {
                btn.classList.remove('is-active');
              }
            });
          }

          const currentTotal = grid.querySelectorAll('.product-card').length;
          
          if (currentTotal >= totalProducts || appendedCount === 0) {
            const wrap = btn.closest('.load-more-wrap');
            if (wrap) wrap.style.display = 'none';
          } else {
            btn.textContent   = originalText;
            btn.disabled      = false;
            btn.style.opacity = '1';
          }

          isLoading = false;
        })
        .catch(function(err) {
          console.error('❌ Error:', err);
          btn.textContent   = originalText;
          btn.disabled      = false;
          btn.style.opacity = '1';
          isLoading         = false;
        });
    });
  }

  /* ════════════════════════════════════════
     QUICK VIEW
     ════════════════════════════════════════ */
  function initQuickView() {
    const overlay = document.getElementById('quickViewOverlay');
    const modal = document.getElementById('quickViewModal');
    const closeBtn = document.getElementById('quickViewClose');
    const content = document.getElementById('quickViewContent');

    if (!overlay || !modal || !closeBtn || !content) {
      console.warn('Quick View elements not found');
      return;
    }

    function openQuickView(productHandle) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';

      content.innerHTML = `
        <div class="quick-view-loading">
          <div class="loading-spinner"></div>
          <p>Loading Product...</p>
        </div>
      `;

      fetch(`/products/${productHandle}?view=quick-view`)
        .then(res => {
          if (!res.ok) throw new Error('Product not found');
          return res.text();
        })
        .then(html => {
          content.innerHTML = html;
          initQuickViewFeatures();
          /* Re-init wishlist buttons inside modal */
          if (window.SmithsWishlist) {
            setTimeout(function() {
              document.querySelectorAll('#quickViewContent .wishlist-toggle').forEach(function(btn) {
                var handle = btn.getAttribute('data-wishlist-handle');
                if (handle && window.SmithsWishlist.has(handle)) {
                  btn.classList.add('is-active');
                }
              });
            }, 80);
          }
        })
        .catch(err => {
          console.error('Quick View error:', err);
          content.innerHTML = `
            <div class="quick-view-loading">
              <p style="color: #8B1A1A;">Error loading product</p>
            </div>
          `;
        });
    }

    function closeQuickView() {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
      
      setTimeout(() => {
        content.innerHTML = `
          <div class="quick-view-loading">
            <div class="loading-spinner"></div>
            <p>Loading...</p>
          </div>
        `;
      }, 300);
    }

    closeBtn.addEventListener('click', closeQuickView);

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeQuickView();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        closeQuickView();
      }
    });

    modal.addEventListener('click', function(e) {
      e.stopPropagation();
    });

    function initQuickViewFeatures() {
      const thumbs = document.querySelectorAll('.qv-thumb');
      const mainImage = document.getElementById('qvMainImage');

      thumbs.forEach(thumb => {
        thumb.addEventListener('click', function() {
          thumbs.forEach(t => t.classList.remove('active'));
          this.classList.add('active');
          
          if (mainImage) {
            mainImage.src = this.dataset.imageUrl;
          }
        });
      });

      const qtyBtns = document.querySelectorAll('.qv-qty-btn');
      const qtyInput = document.getElementById('qvQuantity');

      qtyBtns.forEach(btn => {
        btn.addEventListener('click', function() {
          const action = this.dataset.action;
          let value = parseInt(qtyInput.value) || 1;

          if (action === 'increase') {
            value++;
          } else if (action === 'decrease' && value > 1) {
            value--;
          }

          qtyInput.value = value;
        });
      });

      const variantSelect = document.getElementById('qvVariantSelect');
      const priceElement = document.querySelector('.qv-price, .qv-price-sale');
      const variantIdInput = document.getElementById('qvVariantId');

      if (variantSelect) {
        variantSelect.addEventListener('change', function() {
          const selectedOption = this.options[this.selectedIndex];
          const newPrice = selectedOption.dataset.price;
          
          if (priceElement && newPrice) {
            priceElement.textContent = newPrice;
          }

          if (variantIdInput) {
            variantIdInput.value = this.value;
          }
        });
      }

      const form = document.getElementById('quickViewForm');
      
      if (form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();

          const formData = new FormData(this);
          const submitBtn = this.querySelector('.qv-add-to-cart');
          const originalText = submitBtn.innerHTML;

          submitBtn.disabled = true;
          submitBtn.innerHTML = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          })
            .then(res => res.json())
            .then(data => {
              submitBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 6L9 17l-5-5"/>
                </svg>
                Added to Cart!
              `;

              showNotification('Product added to cart!');
              updateCartCount();

              setTimeout(() => {
                submitBtn.disabled = false;
                submitBtn.innerHTML = originalText;
              }, 2000);
            })
            .catch(err => {
              console.error('Add to cart error:', err);
              submitBtn.disabled = false;
              submitBtn.innerHTML = originalText;
              showNotification('Error adding to cart', true);
            });
        });
      }
    }

    /* Expose globally for card clicks and wishlist.js */
    window.openQuickView = openQuickView;

    console.log('✓ Quick View initialized');
  }

  function showNotification(message, isError = false) {
    let container = document.getElementById('qv-notification');
    
    if (!container) {
      container = document.createElement('div');
      container.id = 'qv-notification';
      container.style.cssText = `
        position: fixed;
        bottom: 30px;
        right: 30px;
        background: rgba(8,8,8,0.95);
        border: 1px solid ${isError ? '#8B1A1A' : '#C9A84C'};
        color: #F5EDD6;
        padding: 16px 24px;
        border-radius: 4px;
        font-family: 'Cinzel', serif;
        font-size: 0.75rem;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        z-index: 10001;
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
      `;
      document.body.appendChild(container);
    }

    container.textContent = message;
    container.style.borderColor = isError ? '#8B1A1A' : '#C9A84C';
    container.style.opacity = '1';

    setTimeout(() => {
      container.style.opacity = '0';
    }, 3000);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(err => console.error('Cart count update error:', err));
  }

  /* ════════════════════════════════════════
     KEYBOARD NAVIGATION
     ════════════════════════════════════════ */
  function initKeyboardNav() {
    document.addEventListener('keydown', function(e) {
      const sortMenu = document.getElementById('sortMenu');
      
      if (!sortMenu) return;

      if (e.key === 'Escape' && sortMenu.classList.contains('open')) {
        sortMenu.classList.remove('open');
        document.getElementById('sortTrigger')?.classList.remove('open');
      }
    });
  }

  /* ════════════════════════════════════════
     INITIALIZE ALL
     ════════════════════════════════════════ */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    detectCollectionType();
    initCardClicks();
    initTabs();
    initSort();
    initViewToggle();
    initRowArrows();
    initReveal();
    initLoadMore();
    initQuickView();
    initKeyboardNav();

    console.log('✓ Collection JS initialized');
  }

  init();

})();